import { lightColorTokens, darkColorTokens } from './colors';
import { defaultTheme } from './defaultTheme';
import { zIndex } from './zIndex';
export const lightTheme = Object.assign(Object.assign({}, defaultTheme), { colors: lightColorTokens, color: lightColorTokens.text, dropShadow: lightColorTokens.lightDropShadowTokens, zIndex });
export const darkTheme = Object.assign(Object.assign({}, defaultTheme), { colors: darkColorTokens, color: darkColorTokens.text, dropShadow: darkColorTokens.darkDropShadowTokens, zIndex });
export const getTheme = (type) => (type === 'light' ? lightTheme : darkTheme);
